import { useRef, useState, useLayoutEffect, } from "react";
/**
 * Returns a ref to attach to an element and a boolean indicating whether that
 * element's content overflows its visible bounds (scrollHeight > clientHeight).
 *
 * Pass `active = false` to pause observation (e.g. when the element is
 * expanded and the clamp class is removed). The last measured value is
 * preserved while inactive, so callers can still show a "See less" button.
 */
function useIsOverflowing(active = true) {
    const ref = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    useLayoutEffect(() => {
        const el = ref.current;
        if (!el || !active) {
            return undefined;
        }
        const check = () => setIsOverflowing(el.scrollHeight > el.clientHeight);
        check();
        const observer = new ResizeObserver(check);
        observer.observe(el);
        return () => {
            observer.disconnect();
        };
    }, [active]);
    return [ref, isOverflowing];
}
export default useIsOverflowing;
